import React from 'react';

import FieldHistoryPanel from '../shared/fieldHistory/FieldHistoryPanel';

import type { DealInformationTab } from './types';
import { useDealFieldHistory } from './useDealFieldHistory';

const PANEL_PREVIEW_SIZE = 5;
const UNTRACKED_MESSAGE = "Salesforce doesn't track field history for this record type.";

interface Props {
  activeTab: DealInformationTab;
  onViewAll?: () => void;
  opportunityId: string | undefined;
}

export default function DealFieldHistoryPanel({ activeTab, onViewAll, opportunityId }: Props) {
  const { entries, error, isLoading, isTracked, totalCount } = useDealFieldHistory(
    activeTab,
    opportunityId,
    PANEL_PREVIEW_SIZE,
  );

  return (
    <FieldHistoryPanel
      emptyMessage={isTracked ? undefined : UNTRACKED_MESSAGE}
      entries={entries}
      error={error}
      isLoading={isLoading}
      onViewAll={onViewAll}
      totalCount={totalCount}
    />
  );
}
